import Typography from "@mui/material/Typography";

import APTable from "../../../components/APTable";
import { toDollars } from "../../../helpers/currencies";
import { DossierSavingsSummary } from "../../../types/Dossier";

export type DossierSavingsAmountField =
  | "annualSavings"
  | "annualisedPayrollTaxSaving";

type TableDataDefinition = {
  employee: string;
  vehicle: string;
  amount: string;
};

const formatVehicleName = (summary: DossierSavingsSummary): string => {
  return [
    summary.vehicleModelyear,
    summary.vehicleMakeName,
    summary.vehicleModelName,
  ]
    .filter(Boolean)
    .join(" ");
};

const formatAmount = (amount: number | null) => {
  return amount !== null ? toDollars(amount, 0) : "";
};

const APDossierSavingsSummary = ({
  savingsSummaries,
  amountField,
  amountHeader,
}: {
  savingsSummaries: DossierSavingsSummary[];
  amountField: DossierSavingsAmountField;
  amountHeader: string;
}) => {
  const savingsSummaryRowRenderer = (
    row: Partial<Record<keyof TableDataDefinition, string>>
  ) => {
    return {
      employee: <Typography variant="bodyMedium">{row.employee}</Typography>,
      vehicle: <Typography variant="bodyMedium">{row.vehicle}</Typography>,
      amount: <Typography variant="bodyMedium">{row.amount}</Typography>,
    };
  };

  const rows: Partial<Record<keyof TableDataDefinition, string>>[] =
    savingsSummaries.map((summary) => {
      return {
        employee: summary.crmContactName,
        vehicle: formatVehicleName(summary),
        amount: formatAmount(summary[amountField]),
      };
    });

  return (
    <APTable
      columns={["employee", "vehicle", "amount"]}
      hideColumnsOnMobile={["vehicle"]}
      headerRows={{
        employee: { title: "Employee" },
        vehicle: { title: "Vehicle" },
        amount: { title: amountHeader },
      }}
      rows={rows}
      rowRenderer={savingsSummaryRowRenderer}
    />
  );
};

export default APDossierSavingsSummary;
